/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext } from 'react'

import { ProtectedNavigationModalProps } from '@/Shared/ui/navigation/atoms/ProtectedNavigationModal'

export interface UIState {
  sidebarCollapsed: boolean
  helperActive: boolean
  helperClosing: boolean
  protectedNavigationModal: ProtectedNavigationModalProps | null
  openSidebar: () => void
  closeSidebar: () => void
  toggleSidebar: () => void
  openHelper: () => void
  closeHelper: () => void
  closingHelper: () => void
  registerNavigationModal: (props: ProtectedNavigationModalProps) => void
  unregisterNavigationModal: () => void
}

const uiVariablesInitialState = {
  sidebarCollapsed: false,
  helperActive: false,
  helperClosing: false,
  protectedNavigationModal: null,
}

const uiMethodsInitialState = {
  openSidebar: (): void => {},
  closeSidebar: (): void => {},
  toggleSidebar: (): void => {},
  openHelper: (): void => {},
  closeHelper: (): void => {},
  closingHelper: (): void => {},
  registerNavigationModal: (): void => {},
  unregisterNavigationModal: (): void => {},
}

export const uiInitialState = {
  ...uiVariablesInitialState,
  ...uiMethodsInitialState,
}

export const UIContext = createContext<UIState>(uiInitialState)
